import * as React from 'react';
import * as _ from 'lodash';
import { IState } from '../reducers/index'
import { connect } from 'react-redux';
import { ISearchResult, IResults, IErrorType } from '../state-helpers/search-results';
import { ISearchCriteria } from '../state-helpers/search-criteria';
import { ICategoryResult } from '../state-helpers/categories';
import { ConnectedSearchBar } from '../components/search-bar/search-bar'
import { SearchResult } from '../components/search-results/search-result'
import { SearchResultsInfo } from '../components/search-results/search-results-info'
import { ToggleFacets } from './categories/facets-toggle'
import { Error } from '../components/search-results/error'
import { NoResults } from '../components/search-results/no-results'
import { EmptyResults } from '../components/search-results/empty'
import { ConnectedCategories } from '../components/categories/categories'
import { ConnectedMobileCategories } from '../components/categories/categories-mobile'
import { ITerm } from '../state-helpers/categories';
import { setPage, setSearchTerm, updateSearchCategory, setMobileCategoriesVisibility, setSelectedCategoryCount } from '../actions/index';
import { fetchResults, getSelectedCategoryCount, setCategoriesAndCount } from '../actions/results'
import { Pagination, IPaginationOptions } from '../components/pagination/pagination';
import { pushInUrlQuery, multiPushInUrlQuery } from 'react-url-query';

class SearchApp extends React.Component<IState, any> {
    isMct: boolean;

    constructor(props) {
        super(props);
        const searchPageMount = document.getElementById('search-page-app');
        this.isMct = searchPageMount.getAttribute('data-mct') === 'true';
    }

    componentWillMount() {
        if (window.location.href.indexOf('?') === -1)
            this.props.dispatch(fetchResults(true, this.isMct));
        else
            this.props.dispatch(fetchResults(false, this.isMct));
    }


    render() {
        let width = window.innerWidth;

        const pagination = {
            items: this.props.resultsModel.totalNumber,
            currentPage: this.props.pageModel.page,
            pageSize: this.props.pageModel.pageSize,
            totalPages: this.props.resultsModel.totalPages
        } as IPaginationOptions;

        return (
            <div className="search-app-container">

                {!this.isMct ? 
                <div className="desktop-facets-wrapper">
                    <ConnectedCategories categories={this.props.categoriesModel.categories}
                        dispatch={this.props.dispatch}
                        onUpdateSearchCategory={(categories: ICategoryResult[]) => this.onUpdateSearchCategory(categories)}
                        isLoading={this.props.resultsModel.loading}
                        numberOfResults={this.props.resultsModel.searchItemList.length}
                        mobileCategoriesVisibility={this.props.categoriesModel.mobileCategoriesVisible}
                        categoriesModel={this.props.categoriesModel} />
                    </div>
                    : null}

                <ul className="search-app-content-wrapper">

                    <ConnectedSearchBar
                        dispatch={this.props.dispatch}
                        totalResults={this.props.resultsModel.totalNumber}
                        showingResults={this.props.resultsModel.searchItemList}
                        pageModel={this.props.pageModel}
                        searchTerm={this.props.searchTermModel}
                        onSearchTermChanged={(searchTerm: string) => this.onSearchTermChanged(searchTerm)}
                        loading={this.props.resultsModel.loading}
                        isMct={this.isMct} />
                    {!this.isMct ?
                        <ConnectedMobileCategories categories={this.props.categoriesModel.categories}
                            dispatch={this.props.dispatch}
                            onUpdateSearchCategory={(categories: ICategoryResult[]) => this.onUpdateSearchCategory(categories)}
                            isLoading={this.props.resultsModel.loading}
                            numberOfResults={this.props.resultsModel.searchItemList.length}
                            mobileCategoriesVisibility={this.props.categoriesModel.mobileCategoriesVisible}
                            categoriesModel={this.props.categoriesModel} />
                        : null }

                    <SearchResultsInfo
                        totalResults={this.props.resultsModel.totalNumber}
                        showingResults={this.props.resultsModel.searchItemList}
                        pageModel={this.props.pageModel}
                        loading={this.props.resultsModel.loading}
                        generativeText={this.props.resultsModel.generativeResult}
                        generativeResultHeader={this.props.resultsModel.generativeResultHeader}
                        disableGenerativeResult={this.props.resultsModel.disableGenerativeResult}
                    />

                    {
                        (this.props.searchTermModel.length > 0 && this.props.resultsModel.showResults && this.props.resultsModel.searchItemList != null && this.props.resultsModel.searchItemList.length === 0 && !this.props.resultsModel.loading)
                            ? <NoResults
                                noResultsWYSIWYG={this.props.resultsModel.noResultsWYSIWYG}
                            />
                            : null
                    }
                    {
                        this.props.resultsModel.errorMessage != ''
                            ? <Error results={this.props.resultsModel}
                                dispatch={this.props.dispatch} />
                            : null
                    }
                    {
                        (this.props.searchTermModel.length == 0 && this.props.resultsModel.searchItemList.length === 0 && !this.props.resultsModel.loading && window.location.search.length == 0)
                            ? <EmptyResults />
                            : null
                    }
                    {
                        !this.props.resultsModel.loading && this.props.resultsModel.searchItemList.length > 0
                            ? this.props.resultsModel.searchItemList.map((result, index) => (<SearchResult result={result} key={index} dispatch={this.props.dispatch} />))
                            : null
                    }
                    {
                        !this.props.resultsModel.loading && this.props.resultsModel.searchItemList.length > 0
                            ? <Pagination pagination={pagination} onPageSelect={(page: number) => this.onPageSelect(page)} />
                            : null
                    }
                </ul>
            </div>
        );
    }

    scrollToTop() {
        document.getElementById("search-page-app").scrollIntoView();
        window.scrollBy(0, -5);

        // Adjust for sticky header
        var stickyHeaderElements = document.getElementsByClassName("header-inner");
        if (stickyHeaderElements.length > 0) {
            window.scrollBy(0, stickyHeaderElements[0].clientHeight * -1);
        }
    }

    onPageSelect(page: number) {
        this.props.dispatch(setPage(page));
        this.props.dispatch(fetchResults(false, this.isMct));
        pushInUrlQuery('page', page);
        this.scrollToTop();
    }

    onSearchTermChanged(searchTerm: string) {
        this.props.dispatch(setSearchTerm(searchTerm));
    }

    onUpdateSearchCategory(category: ICategoryResult[]) {
        this.props.dispatch(setPage(1));
        setCategoriesAndCount(this.props.dispatch, category);
        this.props.dispatch(fetchResults(false, this.isMct));
        var selectedCategories = category
            .map((item, i) => {
                return item.terms.some(f => f.selected === true)
                    ? { name: item.name, fieldName: item.fieldName, terms: item.terms.filter(t => t.selected === true) } : null
            })
            .filter(f => f != null);
        var categoryList = JSON.stringify(selectedCategories);
        multiPushInUrlQuery({ categories: categoryList, page: '1' });
        this.scrollToTop();
    }
}

export const SearchPageApp = connect((state) => state)(SearchApp);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/search-page-app.tsx